export default {
  // 操作栏
  addAssign: '添加赋码',
  // 搜索区
  batchNo: '码批次',
  batchNoPlaceholder: '请输入码批次',
  codeSn: '二维码',
  codeSnPlaceholder: '请输入二维码',
  productName: '产品名称',
  productNamePlaceholder: '请输入产品名称',
  productSn: '产品编号',
  productSnPlaceholder: '请输入产品编号',
  productionBatch: '生产批次',
  productionBatchPlaceholder: '请输入生产批次',
  // 表格列
  colProductInfo: '产品信息',
  colProductionBatch: '生产批次',
  colBatchNo: '码批次',
  colQrcodeRange: '二维码区间',
  colCount: '数量',
  colRemark: '备注',
  colCreatedAt: '添加时间',
  colOperator: '操作人',
  colAction: '操作',
  // 产品信息
  productNo: '产品编号',
  // 生产批次
  batchId: 'ID',
  // 操作
  delete: '删除',
  // 添加赋码弹窗
  addAssignTitle: '添加产品赋码',
  batchNoLabel: '码批次',
  selectBatch: '选择',
  rangeType: '区间范围',
  rangeTypeAll: '整批关联',
  rangeTypeRange: '区间关联',
  assignType: '赋码方式',
  assignTypeProduct: '按产品',
  assignTypeProductionBatch: '按生产批次',
  startQrcode: '开始二维码',
  endQrcode: '结束二维码',
  relatedProduct: '关联产品',
  selectProduct: '选择产品',
  remarkLabel: '备注',
  remarkPlaceholder: '请输入备注',
  batchNoRequired: '请选择码批次',
  productRequired: '请选择关联产品',
  productionBatchRequired: '请选择生产批次',
  selectProductionBatch: '选择',
  startQrcodeRequired: '请输入开始二维码',
  endQrcodeRequired: '请输入结束二维码',
  // 删除确认
  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '确定要删除该条赋码记录吗？',
  // 空状态
  emptyText: '暂无赋码记录',
};
